import { useEffect, useState, useRef, Fragment } from "react";
import { useAppSelector } from "../hooks";
import { getClasses } from "../utils";
import classes from "../styles/Clock.module.css";

const formatNumber = (n: number): string => {
  if (!n) return "00";

  return n.toFixed(0).padStart(2, "0");
};

const formatTime = (date: Date, separator: string = ":"): string => {
  const hours = formatNumber(date.getHours());
  const minutes = formatNumber(date.getMinutes());

  return hours + separator + minutes;
};

const formatTimer = (miliseconds: number) => {
  if (miliseconds < 0) return "--:--";

  const fullSeconds = miliseconds / 1000;
  const seconds = Math.floor(fullSeconds) % 60;
  const minites = Math.floor(fullSeconds / 60) % 60;
  const hours = Math.floor(fullSeconds / 60 / 60);

  const fSeconds = formatNumber(seconds);
  const fMinutes = formatNumber(minites);
  const fHours = formatNumber(hours);

  if (!hours) {
    return `${fMinutes}:${formatNumber(seconds)}`;
  } else {
    return `${fHours}:${fMinutes}:${fSeconds}`;
  }
};

const Clock: React.FC<{ className?: string }> = ({ className }) => {
  const timerStart = useAppSelector((state) => state.details.timer);
  const [date, setDate] = useState(new Date());
  const [timer, setTimer] = useState(0);
  const then = useRef(date);

  useEffect(() => {
    // set the initial value of the timer
    if (timerStart !== null) {
      setTimer(Date.now() - timerStart);
    }

    const id = setInterval(() => {
      const now = new Date();
      if (timerStart != null) {
        setTimer(Date.now() - timerStart);
      }

      if (now.getMinutes() !== then.current.getMinutes()) {
        setDate(now);
        then.current = now;
      }
    }, 1000);

    return () => {
      clearInterval(id);
    };
  }, [timerStart]);

  return (
    <div className={getClasses(classes, className, "clock color text-white")}>
      <span>{formatTime(date)}</span>
      {timerStart != null && (
        <Fragment>
          <span className={classes.separator}>|</span>
          <span className={classes.timer}>{formatTimer(timer)}</span>
        </Fragment>
      )}
    </div>
  );
};

export default Clock;
